import React, { memo, useCallback, useEffect, useMemo, useState } from "react";
import { Button, Modal, Table, TableProps } from "antd";
import { shallowEqual, useSelector } from "react-redux";

import { GoDownload } from "react-icons/go";
import { RxCross2 } from "react-icons/rx";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import "./style.css";
import moment from "moment";




interface PreviewTableProps {
  isModalOpen: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>
  columnHeader?:any[]
  tableData:any[]
  onDownload: () => void;
}

const GeneralisePreviewTable: React.FC<PreviewTableProps> = ({
  isModalOpen,
  setIsModalOpen,
  columnHeader,
  tableData,
  onDownload,
}) => {
  //   const [isModalOpen, setIsModalOpen] = useState(false);


  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };



  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

  return tableData?.length > 0 ? (
    <>
      <Modal
        title={`CSV Preview`}
        closable
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={"80VW"}
        footer={
          <>
            <Button
              type="primary"
              onClick={handleCancel}
              danger
              icon={<RxCross2 size={20} />}
            >
              Cancel
            </Button>

            <Button
              type="primary"
              size="middle"
              onClick={onDownload}
              icon={<GoDownload size={20} />}
            >
              Download
            </Button>
          </>
        }
      >
        <div className="insiderTableDiv">
          <Table<any>
            columns={columnHeader}
            dataSource={tableData}
            scroll={{ x: 70 * 5, y: 55 * 5 }}
          />
        </div>
      </Modal>
    </>
  ) : (
    <Modal
      title={`CSV Preview`}
      closable
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      width={"80VW"}
    >
      <p>No data available</p>
    </Modal>
  );
};

export default memo(GeneralisePreviewTable);
